import { render } from "./issuetrace.vue?vue&type=template&id=68b4fb79"
import script from "./issuetrace.vue?vue&type=script&lang=js"
export * from "./issuetrace.vue?vue&type=script&lang=js"

import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css"
import "./issuetrace.vue?vue&type=style&index=1&id=68b4fb79&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__